import React from 'react';

import './TermsAndPolicyLabel.scss';

const TermsAndPolicyLabel = () => (
  <div className="terms-and-policy-label">
    By clicking "Submit", you agree to Mapbox’s
    <a href="https://www.mapbox.com/legal/tos" target="_blank" rel="noreferrer">
      Terms of Service
    </a>
    and
    <a
      href="https://www.mapbox.com/legal/privacy"
      target="_blank"
      rel="noreferrer"
    >
      Privacy Policy
    </a>
    and our use of your submissions.
  </div>
);

export default TermsAndPolicyLabel;
